<template>
    <div class="indicator_config chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.iconSet.show" @change="getRender">是否展示图标</el-checkbox>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">图标</span>
            <el-dropdown class="updBtn" trigger="click">
                <i class="iconfont" :style="{
                    color:config.iconSet.iconColor,
                }"
                :class="config.iconSet.name"></i>
                <el-dropdown-menu slot="dropdown" class="scrollBar_view_xy">
                    <el-dropdown-item v-for="(item,index) in iconList">
                        <i class="iconfont" style="font-size: 25px" :class="item" @click="config.iconSet.name = item,getRender()"></i>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">图标颜色</span>
            <el-color-picker v-model="config.iconSet.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">图标大小</span>
            <el-input v-model="config.iconSet.fontSize" @change="getRender" type="number" min="12"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">图标上下位置</span>
            <el-input v-model="config.iconSet.lineHeight" @change="getRender" type="number" min="12"></el-input>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">图标位置</span>
            <el-select v-model="config.iconSet.position" placeholder="请选择字体系列"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in positionList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    import iconList from "../../../iocnfont/iconClass";
    export default {
        name: 'indicator_config',
        components: {},
        data() {
            return {
                iconList:iconList.iconList,
                familyList:[
                    {name:'黑体',value:'SimHei'},
                    {name:'宋体',value:'SimSun'},
                    {name:'楷体',value:'KaiTi'},
                    {name:'仿宋',value:'FangSong'},
                    {name:'华文中宋',value:'STZhongsong'},
                    {name:'华文行楷',value:'STXingkai'}
                ],
                valPosition:[
                    {name:'数值在上',value:'top'},
                    {name:'数值在下',value:'bottom'}
                ],
                textAlign:[
                    {name:'左对齐',value:'left'},
                    {name:'居中',value:'center'},
                    {name:'右对齐',value:'right'}
                ],
                positionList:[
                    {name:'左侧',value:'left'},
                    {name:'右侧',value:'right'}
                ]
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    @import "../iocnfont/iconfont.css";
    .indicator_config {
        .chartDivConfig {
            .span_til {
                width: 32%!important;
                max-width: 90px !important;
            }
        }
        .iconfontsel{
            .el-select-dropdown__item{
                display: inline-block;
                width: 24%;
                text-align: center;
            }
        }
        .updBtn {
            i{
                font-size: 25px;color: #000;cursor: pointer;
            }

        }

    }
    .el-dropdown-menu{
        height: 300px !important;
        width: 305px !important;
        overflow: auto;
        overflow-x: hidden;
        >li{
            display: inline-block;
            width: 40px;
            padding: 0;
            text-align: center;
            >i{
                margin: 0;
            }
        }
    }
</style>
